import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import '../../App.css';

const socket = io(process.env.REACT_APP_BACKEND_URL);

export default function Bot() {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [typing, setTyping] = useState(false);
  const chatBodyRef = useRef(null);

  const addMessage = (type, text) => {
    setMessages((prevMessages) => [...prevMessages, { type, text }]);
  };

  const handleSendMessage = () => {
    if (userInput.trim()) {
      addMessage('user', userInput);
      socket.emit('ask-question', userInput);
      setUserInput('');
      setTyping(true);
    }
  };

  useEffect(() => {
    // Listen for bot responses
    socket.on('receive-answer', (response) => {
      setTyping(false);
      addMessage('bot', response);
    });

    return () => {
      socket.off('receive-answer');
    };
  }, []);

  useEffect(() => {
    // Auto-scroll to the bottom of the chat body
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [messages]);

  const renderMessageContent = (text) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: text.replace(
            /Section (\d+)/g,
            '<a href="https://sso.agc.gov.sg/Act/CoA1967?ViewType=Advance&Exact=section+$1&WiAl=1" target="_blank" rel="noopener noreferrer">$&</a>'
          ),
        }}
        style={{ fontFamily: "'Arial', sans-serif" }} 

      />
    );
  };
  

  return (
    <div className="chat-container">
      <div className="chat-header">
      <img className="icon-bot" src="assets/img/logos/inprovedLogo.svg" alt="Bot Icon" />
      Chat with inProvedAI
      </div>
      <div className="chat-body" ref={chatBodyRef}>
        {messages.map((msg, index) => (
          <div key={index} className={`chat-message ${msg.type}-message`}>
            <div className="message-content">{renderMessageContent(msg.text)}</div>
          </div>
        ))}
        {typing && <div className="typing-indicator">Bot is typing...</div>}
      </div>
      <div className="chat-footer">
        <input
          type="text"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder="Ask a question..."
          disabled={typing}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleSendMessage();
            }
          }}
        />
        <button onClick={handleSendMessage} disabled={typing}>
          {typing ? <div className="spinner"></div> : 'Send'}
        </button>
      </div>
    </div>
  );
}
